const SALEM_ROUTE_COPY = {
  Chennai: {
    leaveHero:
      'Book a one-way taxi from Salem to Chennai, then edit pickup or drop if you need a more specific address.',
    returnHero:
      'Leave Chennai for Salem in a one-way cab. Pickup and drop are pre-filled for this inbound leg and stay editable.',
    leaveIntro: [
      'Salem to Chennai is the eastbound outstation taxi from the highway city toward the capital. It is useful when you need a cab that continues after time in Salem rather than a local city hire.',
      'Pickup defaults to Salem. Drop defaults to Chennai. Type a hotel, factory or Chennai Airport if that is the actual start or finish. Do not switch pickup to Chinna Salem unless that is truly where you will board.',
      'There is no Salem–Chennai package fare. After Get Fare Estimate, Sedan, SUV and Crysta show totals from the live mapped drive plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Chennai to Salem is for leaving the capital toward the highway city. It is a separate page because pickup starts in Chennai, not in Salem, and the drive is mapped in this direction.',
      'Keep or edit Chennai as pickup and Salem as drop. Airport or hotel edits are field changes, not a second booking system.',
      'One Way is the default so you are not holding a cab in Salem unless you switch to Round Trip.',
    ],
    leaveTravel:
      'You leave Salem and continue in the same taxi toward Chennai. Distance on this page comes from the live map for that pickup and drop.',
    returnTravel:
      'You board in Chennai and continue to Salem as its own mapped drive. This reverse does not reuse the outbound Salem kilometre.',
    leaveMeta:
      'Book a one-way Salem to Chennai taxi with Easy Drop Taxi. Pickup starts in Salem, drop in Chennai, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Chennai to Salem taxi with Easy Drop Taxi. Pickup starts in Chennai, drop in Salem, and both fields stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same as Coimbatore to Chennai?',
        answer:
          'No. Coimbatore to Chennai already has a catalogue URL. This page is only Salem to Chennai.',
      },
      {
        question: 'Can I finish at a specific point in Chennai?',
        answer:
          'Yes. Drop is a starting label. Type a lodging, office or Chennai Airport before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from Chennai Airport rather than the city name?',
        answer:
          'Yes. Pickup defaults to Chennai but you can type Chennai Airport or another mapped point before you estimate.',
      },
      {
        question: 'Does this reverse copy the Salem to Chennai kilometre?',
        answer:
          'No. Chennai to Salem is mapped when you search on this page. The outbound Salem URL is a different booking start.',
      },
    ],
  },
  Coimbatore: {
    leaveHero:
      'Book a one-way Salem to Coimbatore taxi online, then edit pickup or drop if you have a precise address.',
    returnHero:
      'Leave Coimbatore for Salem in a one-way cab through the same Easy Drop Taxi booking form.',
    leaveIntro: [
      'Salem to Coimbatore is a southwest taxi toward Easy Drop Taxi’s home city. It is booked as one vehicle for the full run, not as a local Salem hire.',
      'Pickup starts in Salem. Drop starts as Coimbatore. Change pickup if you are leaving from a hotel or factory. Change drop if you need Coimbatore Airport or another mapped point.',
      'This pair is not one of the locked Coimbatore-origin catalogue URLs. Fare still follows billed live kilometres, the published vehicle rate and driver bata.',
    ],
    returnIntro: [
      'Coimbatore to Salem is the northeast taxi into the highway city. Book it when you only need that inbound ride, not a round trip held from Salem.',
      'The card opens on Coimbatore pickup and Salem drop. Both fields stay editable. One Way is the default because this page is the reverse leg.',
      'Live mapping for Coimbatore to Salem is loaded on this page independently. Coimbatore’s 54 destination pages do not include Salem, so this URL is a separate extra pair.',
    ],
    leaveTravel:
      'You leave Salem and continue in the same taxi toward Coimbatore. Travel time depends on the live mapped drive and traffic, not a catalogue hour.',
    returnTravel:
      'The inbound taxi starts in Coimbatore and finishes in Salem. Mapping for this reverse is separate from the Salem-origin page.',
    leaveMeta:
      'Book a one-way Salem to Coimbatore taxi with Easy Drop Taxi. Pickup starts in Salem, drop in Coimbatore, and the fare uses the live mapped estimate.',
    returnMeta:
      'Book a Coimbatore to Salem one-way taxi with Easy Drop Taxi. Pickup starts in Coimbatore, drop in Salem, and both locations stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same as a Coimbatore catalogue route?',
        answer:
          'No. Coimbatore’s locked destination list does not include Salem. This landing is the Salem–Coimbatore pair. Open a Coimbatore-origin catalogue page only when you are actually leaving Coimbatore for one of those listed cities.',
      },
      {
        question: 'Can I start from a factory in Salem?',
        answer:
          'Yes. Change pickup to a more specific mapped Salem address, keep Coimbatore as drop or edit it, then estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I finish this Coimbatore to Salem taxi at a hotel in Salem?',
        answer:
          'Yes. Keep Coimbatore as pickup or edit it, change drop to a mapped Salem address if that is where you will alight, then estimate as usual.',
      },
      {
        question: 'Does this reverse page copy the outbound Salem kilometre?',
        answer:
          'No. Coimbatore to Salem is mapped on its own when you search. The outbound Salem to Coimbatore page is a separate URL.',
      },
    ],
  },
  Madurai: {
    leaveHero:
      'Book a one-way taxi from Salem to Madurai, then edit pickup or drop if you need a tighter address.',
    returnHero:
      'Leave Madurai for Salem in a one-way cab. Pickup and drop are set for this return leg and stay editable.',
    leaveIntro: [
      'Salem to Madurai is a southbound outstation taxi from the highway city toward the temple city. Travellers usually want one vehicle for the full run rather than changing midway.',
      'Pickup defaults to Salem. Drop defaults to Madurai. Type a hotel, junction or Madurai Airport if that is the actual start or finish.',
      'This is not the dedicated Madurai to Chennai page and it is not a Madurai hub substitute. Fare here still uses live mapping plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Madurai to Salem is for leaving the temple city toward the highway city. It is a separate page because pickup starts in Madurai, not in Salem, and the drive is mapped in this direction.',
      'Keep or edit Madurai as pickup and Salem as drop. Airport or hotel edits are field changes, not a second booking system.',
      'One Way is the default so you are not holding a cab in Salem unless you switch to Round Trip.',
    ],
    leaveTravel:
      'You leave Salem and continue in the same taxi toward Madurai. Distance on this page comes from the live map for that pickup and drop.',
    returnTravel:
      'You board in Madurai and continue to Salem as its own mapped drive. This reverse does not reuse the outbound Salem kilometre.',
    leaveMeta:
      'Book a one-way Salem to Madurai taxi with Easy Drop Taxi. Pickup starts in Salem, drop in Madurai, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Madurai to Salem taxi with Easy Drop Taxi. Pickup starts in Madurai, drop in Salem, and both fields stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same as Madurai to Chennai?',
        answer:
          'No. Madurai to Chennai already has a dedicated page. This URL is only Salem to Madurai.',
      },
      {
        question: 'Can I finish at a specific point in Madurai?',
        answer:
          'Yes. Drop is a starting label. Type a lodging, junction or Madurai Airport before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from Madurai Airport rather than the city name?',
        answer:
          'Yes. Pickup defaults to Madurai but you can type Madurai Airport or another mapped point before you estimate.',
      },
      {
        question: 'Does this reverse copy the Salem to Madurai kilometre?',
        answer:
          'No. Madurai to Salem is mapped when you search on this page. The outbound Salem URL is a different booking start.',
      },
    ],
  },
  Trichy: {
    leaveHero:
      'Book a one-way taxi from Salem to Trichy, then edit pickup or drop if you need a more specific address.',
    returnHero:
      'Leave Trichy for Salem in a one-way cab. Pickup and drop are pre-filled for this inbound leg and stay editable.',
    leaveIntro: [
      'Salem to Trichy is a southeast taxi from the highway city toward Tiruchirappalli. It is booked when you need a door-to-door cab rather than a local Salem drop.',
      'Pickup starts as Salem. Drop starts as Trichy — the spelling used on this landing page. Type Trichy Airport or another mapped Tiruchirappalli point if that is where you will alight.',
      'This pair is not a Trichy hub substitute. Fare still comes from the live mapped drive, the published tariff and driver bata.',
    ],
    returnIntro: [
      'Trichy to Salem is for leaving Tiruchirappalli toward the highway city. It is a separate landing page because pickup starts in Trichy, not in Salem.',
      'Keep or edit Trichy as pickup and Salem as drop. One Way stays selected unless you need Round Trip.',
      'Live mapping for this reverse is independent of the outbound Salem kilometre and of the other Trichy priority pairs.',
    ],
    leaveTravel:
      'You leave Salem and continue in the same taxi toward Trichy. Distance and time come from the live map for that pickup and drop.',
    returnTravel:
      'You board in Trichy and continue to Salem as its own mapped drive. This page does not reuse the outbound Salem kilometre.',
    leaveMeta:
      'Book a one-way Salem to Trichy taxi with Easy Drop Taxi. Pickup starts in Salem, drop in Trichy, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Trichy to Salem taxi with Easy Drop Taxi. Pickup starts in Trichy, drop in Salem, and both fields stay editable.',
    leaveFaqs: [
      {
        question: 'Should I type Trichy or Tiruchirappalli as the drop?',
        answer:
          'This page defaults to Trichy because that is the hub spelling. If Google Places suggests Tiruchirappalli for your exact point, you can accept that suggestion.',
      },
      {
        question: 'Is this the same as Trichy to Chennai?',
        answer:
          'No. Trichy to Chennai already has its own pair URL. Use this page when pickup is Salem and drop is Trichy.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from Trichy Airport rather than the city name?',
        answer:
          'Yes. Pickup defaults to Trichy but you can type Trichy Airport or another mapped point before you estimate.',
      },
      {
        question: 'Should I use the Salem to Trichy page for the return?',
        answer:
          'No. Book Trichy to Salem here. The outbound Salem page is a different URL with a different pickup default.',
      },
    ],
  },
};

export const getSalemRouteProfile = (place) => SALEM_ROUTE_COPY[place] || null;

export const SALEM_EXTRA_DESTINATIONS = ['Chennai', 'Coimbatore', 'Madurai', 'Trichy'];

export const SALEM_ROUTE_HUB = 'Salem';

export const SALEM_PRIORITY_DESTINATIONS = [
  'Chennai',
  'Coimbatore',
  'Bangalore',
  'Madurai',
  'Trichy',
];
